import type { MagentoShippingMethod } from "@jti/magento-types";

import { useShippingOptionLabels } from "../../hooks";

import styles from "./ShippingOptionLabel.module.scss";

type ShippingOptionLabelProps = {
  magentoShippingMethod: MagentoShippingMethod;
};

export const ShippingOptionLabel = ({ magentoShippingMethod }: ShippingOptionLabelProps) => {
  const getShippingOptionLabel = useShippingOptionLabels();

  const { title, subtitle } = getShippingOptionLabel(magentoShippingMethod);

  return (
    <div className={styles.label}>
      <span className={styles.title}>{title}</span>
      <span className={styles.subLabel}>{subtitle}</span>
    </div>
  );
};
